export default "__VITE_ASSET__CHq$f7Xc__"